import React, { useContext, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import decode from "jwt-decode";
import axios from "axios";
import { setIdleTimer } from "state/actions/idleTimer";
import {
  setRoles,
} from "state/actions/user";
import { useLocation, useHistory } from "react-router-dom";
import { ServerNotificationsContext } from "components/common";
import useMount from "utils/hooks/useMount";
import useLogout from "utils/hooks/useLogout";

const SetupContainer = ({ children }) => {
  const { getServerNotifications } = useContext(ServerNotificationsContext);
  const [loading, setLoading] = useState(true);
  const logout = useLogout();
  const location = useLocation();
  const publicRoutes = ["/stripe-redirect", "/confirmpassword", "/login", "/signup", "/passwordrecovery", "/manage", "/tomo-boost-confirm", "/boost/checkout", "/boost/pricing"];

  const dispatch = useDispatch();
  const history = useHistory();

  const replaceHashPath = () => {
    if (location.hash) {
      const path = location.hash.replace(/^#/, '');
      if (path) {
        history.replace(path);
      }
    }
  };

  useMount(() => {
    replaceHashPath();
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      axios
        .post(
          "/login/verify",
          {},
          {
            headers: { Authorization: `Bearer ${jwt}` },
          },
        )
        .then((response) => {
          const { token: newToken } = response.data || {};
          const { roles = {} } = decode(newToken || jwt);

          if (response.data.verified) {
            if (newToken) {
              window.localStorage.setItem("jwt", newToken);
            }
            getServerNotifications();
            dispatch(setIdleTimer(true, roles?.admin));
            dispatch(setRoles(roles));
          } else {
            logout();
          }
        })
        .catch((error) => {
          console.log(error);
          logout();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      if (!publicRoutes.includes(location.pathname)) {
        logout();
      }
      setLoading(false);
    }
  });

  return (
    <>
      <Helmet>
        <script src={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_FIREBASE_API_KEY}&callback=Function.prototype&libraries=places`} />
      </Helmet>
      <Helmet>
        <script type="text/javascript">
          {`window.zESettings = {
        webWidget: {
          offset: {
            mobile: {
              vertical: '80px'
            }
          },
        }
      };`}
        </script>
      </Helmet>
      {/* <Helmet> */}
      {/* <!-- Hotjar Tracking Code for https://www.tomocredit.com/ --> */}
      {/* <script>
          {`(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:1956626,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`} */}
      {/* </script> */}
      {/* </Helmet> */}
      <Helmet>
        <script src="https://connect2.finicity.com/assets/sdk/finicity-connect.min.js" />
      </Helmet>
      {!loading && children}
    </>
  );
};
export default SetupContainer;
